import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { AdminBannerAllData } from '../fragments';

export default gql`
query bannerListAll($filters: AdminBannerFilters, $sortBy: AdminBannerOrder, $count: Int!, $page: Int) {
    adminBanners(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminBannerAllData
        }
    }
}
${PaginatorInfoFragment}
${AdminBannerAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/bannerListAll.ts